import React from 'react';
import './FileChip.scss';

interface FileChipProps {
  file: File;
  onRemove: () => void;
}

const FileChip = ({ file, onRemove }: FileChipProps) => (
  <div className="file_chip">
    <span className="file_chip_icon">📄</span>
    <span className="file_chip_name">{file.name}</span>
    <span className="file_chip_size">{(file.size / 1024).toFixed(1)} KB</span>
    <button className="file_chip_remove" onClick={onRemove} title="Remove file">
      ✕
    </button>
  </div>
);

export default FileChip;